import Naluri from '~/common/api/naluri';
import {
  COMMON_SET_TO_REPLY_BEGIN,
  COMMON_SET_TO_REPLY_SUCCESS,
  COMMON_SET_TO_REPLY_FAILURE,
  COMMON_SET_TO_REPLY_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function setToReply(channelID, params) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_SET_TO_REPLY_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      const doRequest = Naluri.post(`/api/${channelID}/to_reply`, params);
      doRequest.then(
        res => {
          dispatch({
            type: COMMON_SET_TO_REPLY_SUCCESS,
            data: {
              id: channelID,
              toReply: params['to_reply'],
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: COMMON_SET_TO_REPLY_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSetToReplyError() {
  return {
    type: COMMON_SET_TO_REPLY_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SET_TO_REPLY_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        setToReplyPending: true,
        setToReplyError: null,
      };

    case COMMON_SET_TO_REPLY_SUCCESS:
      // The request is success
      return {
        ...state,
        workingChannelInfo: {
          ...state.workingChannelInfo,
          to_reply: action.data.toReply,
        },
        // channels: state.channels.map(c =>
        //   c.id === action.data.id ? Object.assign({}, c, { to_reply: action.data.toReply }) : c,
        // ),
        setToReplyPending: false,
        setToReplyError: null,
      };

    case COMMON_SET_TO_REPLY_FAILURE:
      // The request is failed
      return {
        ...state,
        setToReplyPending: false,
        setToReplyError: action.data.error,
      };

    case COMMON_SET_TO_REPLY_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        setToReplyError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/setToReply.js